import { Paper as MUIPaper } from '@mui/material';
import { ContainerProps } from '../../models/Props.types';

export default function Paper(props: ContainerProps) {
    return <MUIPaper sx={props.sx}>{props.children}</MUIPaper>;
}
